import styles from "./Loading.module.css";

const Loading = ({

    text = "در حال بارگذاری..."

}) => {

    return (

        <div className={styles.container}>

            <div className={styles.spinner} />

            <span>

                {text}

            </span>

        </div>

    );

};

export default Loading;